import React, { useMemo } from "react";

import { Marker } from "react-map-gl/maplibre";
import errorTracker from "~/utils/errorTracker";

import { Icon } from "@local-logic/core/icons";
import type { MarkerProps } from "../types";

import * as styles from "../styles";

export const MapGLMarker = ({ lat, lng, icon, onClick }: MarkerProps) => {
  /**
   * We need to cache the icon because changes in markers are not immediate. If we don't,
   * then the new icon will briefly display on the old markers until the new markers are
   * populated.
   */
  const markerIcon = useMemo(() => icon, []);

  const handleOpenPopup = () => {
    if (!onClick) {
      return;
    }

    errorTracker.addBreadCrumb("MapGLMarker", "handleOpenPopup", { lat, lng });

    onClick();
  };

  return (
    <Marker
      latitude={lat}
      longitude={lng}
      anchor="bottom"
      onClick={(e) => {
        e.originalEvent.stopPropagation();
        handleOpenPopup();
      }}
    >
      <div className={styles.container}>
        <Icon icon={markerIcon || "Record"} className={styles.icon} />
        <svg
          width="20"
          height="28"
          viewBox="0 0 20 28"
          fill="none"
          className={styles.background}
        >
          <path
            d="M20 10C20 15.5228 12 27.5 10 27.5C8 27.5 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10Z"
            fill="inherit"
          />
        </svg>
      </div>
    </Marker>
  );
};
